// Canonical URL key for link-preview tooltips, shared by the import pipeline
// (scripts/planA/linkPreviews.ts, which generates the URL → markdown map from
// the "Link Previews" tab) and the runtime lookup in
// app/common/blocks/linkTooltips.tsx. Both sides MUST normalize through this
// one function or map keys and hover lookups drift apart.
//
// The gdoc exporter sometimes wraps a URL in a Google redirect
// (`<real-url>&sa=D&source=editors&ust=…&usg=…`),
// and trailing slashes vary between imports — normalize both away, plus any
// `#fragment` (an anchor into a page is still that page), so every variant of
// a URL resolves to the same key.
export function normalizeLinkTooltipUrl(url: string): string {
  return unwrapGoogleRedirect(url.trim())
    .replace(/#.*$/, '')
    .replace(/\/+$/, '');
}

// Unwrap the google.com/url?q= redirect to its real target (searchParams.get
// percent-decodes it); a non-redirect or unparseable URL is its own target.
function unwrapGoogleRedirect(url: string): string {
  try {
    const parsed = new URL(url);
    if (/(^|\.)google\.com$/i.test(parsed.hostname) && parsed.pathname === '/url') {
      return parsed.searchParams.get('q') || url;
    }
    return url;
  } catch {
    return url;
  }
}
